import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ToastService from 'primevue/toastservice'
import { createPinia } from 'pinia'
import './assets/main.css'
import Tooltip from 'primevue/tooltip';

import PrimeVue from 'primevue/config'
import { definePreset } from '@primeuix/themes';
import Material from '@primeuix/themes/material';
import 'primeicons/primeicons.css'
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Row from 'primevue/row';
import ColumnGroup from 'primevue/columngroup';
import Toolbar from 'primevue/toolbar';
import Button from 'primevue/button';
import FileUpload from 'primevue/fileupload';
import InputIcon from 'primevue/inputicon';
import InputText from 'primevue/inputtext';
import InputMask from 'primevue/inputmask';
import IconField from 'primevue/iconfield';
import Rating from 'primevue/rating';
import Tag from 'primevue/tag';
import Dialog from 'primevue/dialog';
import InputNumber from 'primevue/inputnumber';
import RadioButton from 'primevue/radiobutton';
import TextArea from 'primevue/textarea';
import Select from 'primevue/select';
import Avatar from 'primevue/avatar';
import DatePicker from 'primevue/datepicker';
import FloatLabel from 'primevue/floatlabel';
import SplitButton from 'primevue/splitbutton';
import ConfirmDialog from 'primevue/confirmdialog';
import ConfirmPopup from 'primevue/confirmpopup';
import Popover from 'primevue/popover';
import ConfirmationService from 'primevue/confirmationservice';
import Checkbox from 'primevue/checkbox';
import CheckboxGroup from 'primevue/checkboxgroup';
import Password from 'primevue/password';
import Message from 'primevue/message';
import Divider from 'primevue/divider';
import Card from 'primevue/card';
import Dropdown from 'primevue/dropdown';
import Menubar from 'primevue/menubar';
import Chip from 'primevue/chip';
import Chips from 'primevue/chips';
import OverlayBadge from 'primevue/overlaybadge';
import Image from 'primevue/image';
import DataView from 'primevue/dataview';
import SelectButton from 'primevue/selectbutton';
import Breadcrumb from 'primevue/breadcrumb';
import Fieldset from 'primevue/fieldset';
import OrderList from 'primevue/orderlist';
// import ThemeSwitcher from 'primevue/themeswitcher';

import Sidebar from './views/Sidebar.vue'
import Topbar from './views/Topbar.vue'

const MyPreset = definePreset(Material, {
    semantic: {
        focusRing: {
            width: '5px',
            style: 'dashed',
            color: '{primary.color}',
            offset: '1px'
        },
        primary: {
            50:  '{noir.50}',
            100: '{noir.100}',
            200: '{noir.200}',
            300: '{noir.300}',
            400: '{noir.400}',
            500: '{noir.500}',
            600: '{noir.600}',
            700: '{noir.700}',
            800: '{noir.800}',
            900: '{noir.900}',
            950: '{noir.950}'
        },
        colorScheme: {
            light: {
                surface: {
                    0: '#ffffff',
                    50:  '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                },
                formField: {
                    hoverBorderColor: '{primary.color}',
                    paddingX: '0.5rem',
                    paddingY: '0.25rem',
                },
                datePicker: {
                    iconColor: '{primary.color}',
                    paddingX: '0.5rem',
                    paddingY: '0.25rem',
                }
            },
        }
    },
    components: {
        button: {
            colorScheme: {
                light: {
                    root: {
                        paddingX: '0.5rem',
                        paddingY: '0.25rem',
                    },

                }
            }
        },
        dataTable: {
            colorScheme: {
                light: {
                    root: {
                        paddingX: '0.5rem',
                        paddingY: '0.25rem',
                    },

                }
            },
            columnHeaderContent: {
                class: 'justify-center',
            },
            rowCell: {
              class: 'justify-center'
            },
            headerCell: {
              class:'justify-center',
            },
            bodyCell: {
              class: 'justify-center',
            }
        }
    },
    options: {
        cssLayer: {
            name: 'material'
        }
    }
});

const app = createApp(App)
app.use(router)
app.use(createPinia())
app.use(ToastService)
app.use(ConfirmationService)
app.mount('#app')
app.use(PrimeVue, {
    theme: {
        // preset: Material,
        preset: MyPreset,
         options: {
            prefix: "p",
            darkModeSelector: "none",
            cssLayer: false
        },
    },
    pt: {
        button: {
            root: 'py-1 px-2'
        }
    }
});
app.component('ConfirmDialog', ConfirmDialog)
app.component('Avatar', Avatar)
app.component('DataTable', DataTable)
app.component('Row', Row)
app.component('Column', Column)
app.component('ColumnGroup', ColumnGroup)
app.component('Toolbar', Toolbar)
app.component('InputText', InputText)
app.component('InputIcon', InputIcon)
app.component('InputMask', InputMask)
app.component('Button', Button)
app.component('FileUpload', FileUpload)
app.component('IconField', IconField)
app.component('Rating', Rating)
app.component('Tag', Tag)
app.component('Dialog', Dialog)
app.component('Dropdown', Dropdown)
app.component('InputNumber', InputNumber)
app.component('RadioButton', RadioButton)
app.component('Textarea', TextArea)
app.component('Select', Select)
app.component('DatePicker', DatePicker)
app.component('SplitButton', SplitButton)
app.component('FloatLabel', FloatLabel)
app.directive('tooltip', Tooltip);
app.component('ConfirmPopup', ConfirmPopup)
app.component('Popover', Popover)
app.component('Checkbox', Checkbox)
app.component('CheckboxGroup', CheckboxGroup)
app.component('Password', Password)
app.component('Message', Message)
app.component('Divider', Divider)
app.component('Card', Card)
app.component('Topbar', Topbar)
app.component('Sidebar', Sidebar)
app.component('Menubar', Menubar);
app.component('Chip', Chip);
app.component('Chips', Chips);
app.component('OverlayBadge', OverlayBadge);
app.component('Image', Image);
app.component('DataView', DataView);
app.component('SelectButton', SelectButton);
app.component('Breadcrumb', Breadcrumb);
app.component('Fieldset', Fieldset);
app.component('OrderList', OrderList);
// app.component('ThemeSwitcher', ThemeSwitcher);